import { SiReact, SiJavascript, SiSass, SiFigma, SiVercel, SiNextdotjs, SiStyledcomponents, SiExpress, SiHtml5, SiCss3, SiTailwindcss, SiRedux } from "react-icons/si";
import { BsFillBootstrapFill, BsStripe, BsGit } from "react-icons/bs";
import { BiLogoNetlify, BiLogoFirebase, BiLogoTypescript, BiLogoNodejs, BiLogoBootstrap, BiLogoJavascript } from "react-icons/bi";
import { AiFillHtml5 } from "react-icons/ai";
import { FaCss3Alt, FaReact, FaSass, FaFigma } from "react-icons/fa";
import { GrMysql } from "react-icons/gr";

export const ICON = {
  SiFigma ,
  SiRedux,
  SiTailwindcss,
  FaReact,
  FaSass,
  FaFigma,
  GrMysql,
  FaCss3Alt,
  BiLogoJavascript,
  BiLogoBootstrap,
  BsGit, 
  AiFillHtml5,
  SiReact,
  SiJavascript,
  SiSass,
  SiVercel,
  SiNextdotjs,SiStyledcomponents,
  SiExpress,
  SiHtml5,
  SiCss3,
  BsFillBootstrapFill,
  BsStripe,
  BiLogoNetlify,
  BiLogoFirebase,
  BiLogoTypescript,
  BiLogoNodejs,
};
